import { render } from "./PublicacoesView.vue?vue&type=template&id=6b5b7332&scoped=true"
import script from "./PublicacoesView.vue?vue&type=script&lang=js"
export * from "./PublicacoesView.vue?vue&type=script&lang=js"

import "./PublicacoesView.vue?vue&type=style&index=0&id=6b5b7332&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b5b7332"]])

export default __exports__